import React from 'react';
import { Icon, IconProps } from './Icon';

export const CrossIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      strokeWidth={0.1}
      viewBox="0 0 12 12"
      height="12"
      width="12"
      {...props}
    >
      <path
        d="M11 1L1 11M1 1L11 11"
        stroke="#D21717"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};
